<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.99998 9.04199C12.5833 9.04199 14.75 7.12533 14.75 4.67199C14.75 2.29533 12.6666 0.301996 9.99998 0.301996C7.33332 0.22533 5.16665 2.142 5.16665 4.59533C5.16665 7.04866 7.33332 9.04199 9.99998 9.04199Z"
    fill="#748097" />
  <path
    d="M18.4167 18.6253H1.58333C1.08333 18.6253 0.75 18.3187 0.75 17.8587V15.8653C0.75 13.0287 3.16667 10.7287 6.33333 10.7287H13.6667C16.6667 10.7287 19.25 12.952 19.25 15.8653V17.8587C19.1667 18.3187 18.75 18.6253 18.4167 18.6253Z"
    fill="#748097" />
</svg>
  